import axios from 'axios';

const httpGetCustomFields = () => {
  return axios.get('/api/v2/contacts/customfields');
};

export { httpGetCustomFields };
